import { useApi } from '@/api';
import { Link, TableSkeleton } from '@/components';
import { tokensMappingBase } from '@/utils/tokens';
import {
  CryptoIcon,
  CurrencyValue,
  DataTable,
  EtherScanPictogram,
  Flex,
  RelativeDateTime,
  WalletAddress
} from '@blockanalitica/ui';
import { TableColumn } from '@blockanalitica/ui/package/types/src/components/molecules/DataTable';

export default function TokenDepositorsTable({ pagination, sorting, search }) {
  const [data, error] = useApi({
    url: `/base/psm3/depositors/`,
    queryParams: {
      p: pagination.currentPage,
      p_size: pagination.pageSize,
      order: sorting.currentSorting,
      search: search
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    const columns: TableColumn[] = [
      {
        header: 'Wallet',
        getCell: (row) => (
          <Link to={`/base/psm3/depositors/${row.wallet_address}`}>
            <WalletAddress
              address={row.wallet_address}
              options={{ sizes: { blockie: '0' } }}
            />
          </Link>
        )
      },
      {
        header: (
          <Flex
            display="flex"
            flexDirection="row"
            alignItems="center"
            gap="3xs">
            USDS Balance
            <CryptoIcon
              name={'USDS'}
              address={tokensMappingBase('USDS').address}
              network="base"
              size="0"
            />
          </Flex>
        ),
        getCell: (row) => <CurrencyValue value={row.usds_balance} />,
        getCellBottom: (row) => (
          <CurrencyValue
            fontSize="-1"
            value={row.usds_balance_change}
            options={{ trend: true, iconSize: '-1' }}
          />
        ),
        cellAlign: 'flex-end',
        headerAlign: 'flex-end',
        sortingField: 'usds_balance'
      },
      {
        header: (
          <Flex
            display="flex"
            flexDirection="row"
            alignItems="center"
            gap="3xs">
            sUSDS Balance
            <CryptoIcon
              name={'sUSDS'}
              address={tokensMappingBase('sUSDS').address}
              network="base"
              size="0"
            />
          </Flex>
        ),
        getCell: (row) => <CurrencyValue value={row.susds_balance} />,
        getCellBottom: (row) => (
          <CurrencyValue
            fontSize="-1"
            value={row.susds_balance_change}
            options={{ trend: true, iconSize: '-1' }}
          />
        ),
        cellAlign: 'flex-end',
        headerAlign: 'flex-end',
        sortingField: 'usds_balance'
      },
      {
        header: (
          <Flex
            display="flex"
            flexDirection="row"
            alignItems="center"
            gap="3xs">
            USDC Balance
            <CryptoIcon
              name={'USDC'}
              address={tokensMappingBase('USDC').address}
              network="base"
              size="0"
            />
          </Flex>
        ),
        getCell: (row) => <CurrencyValue value={row.usdc_balance} />,
        getCellBottom: (row) => (
          <CurrencyValue
            fontSize="-1"
            value={row.usdc_balance_change}
            options={{ trend: true, iconSize: '-1' }}
          />
        ),
        cellAlign: 'flex-end',
        headerAlign: 'flex-end',
        sortingField: 'usds_balance'
      },

      {
        header: 'Latest Activity',
        getCell: (row) => (
          <Flex gap={['xs', '2xs']} color="muted">
            <RelativeDateTime value={row.datetime} />
            <a
              href={`https://basescan.org/tx/${row.tx_hash}`}
              target="_blank"
              rel="noreferrer">
              <EtherScanPictogram size="0" />
            </a>
          </Flex>
        ),
        sortingField: 'order_index',
        cellAlign: 'flex-end',
        headerAlign: 'flex-end'
      }
    ];

    return (
      <DataTable
        rows={data['results']}
        columns={columns}
        getKey={(row) => row.wallet_address}
        sorting={sorting}
        pagination={{
          ...pagination,
          totalRecords: data.count
        }}
      />
    );
  }
  return <TableSkeleton />;
}
